import React, { useEffect, useMemo, useState } from "react";
import {
  Outlet,
  NavLink,
  useNavigate,
  useParams,
  useLocation,
} from "react-router-dom";
import { ChevronDown, X, Menu } from "lucide-react";
import { BiSupport } from "react-icons/bi";
import apiClient from "../../../config/apiClient";
import FaviconImg2 from "../../../assets/new-images/Logo.ico";
// import FaviconImg from "../../../assets/new-images/Logo.ico";
// import FaviconImg from "../../../assets/new-images/simplifyte.com - Logo.png";
import FaviconImg from "../../../assets/new-images/App Icon Dark.png";
import "../../../assets/css/custom.css";

import "./ReDesign.css";
import { Helmet } from "react-helmet";
import { pageMetadata } from "../../../config/pageMetadata";
import SEO from "../../../config/SEO";
import { DocCard } from "./DocsHomeLinear";
const SUPPORT_ROUTE = "/contactsales"; // ✅ change if needed

const iconFor = (key) => {
  const ICONS = {
    document: "📘",
    check: "✔️",
    users: "👥",
    plug: "🔌",
    card: "💳",
    lock: "🔒",
    rocket: "🚀",
    bulb: "💡",
    settings: "⚙️",
    chart: "📊",
    target: "🎯",
    star: "🌟",
    cap: "🎓",
    book_open: "📖",
    "book-open": "📖", // ✅ FIX
    "folder-open": "📁", // ✅ FIX
  };
  return ICONS[key] || "📄";
};

export default function DocsLayout() {
  const navigate = useNavigate();
  const { slug } = useParams();
  const location = useLocation();
  const doc_id = location.state?.id;
  const [categories, setCategories] = useState([]);
  const [loading, setLoading] = useState(true);
  const [openCats, setOpenCats] = useState({});
  const [menuOpen, setMenuOpen] = useState(false);
  const [openCategory, setOpenCategory] = useState({});
  const [openCategoryId, setOpenCategoryId] = useState(null);
  const [activeId, setActiveId] = useState(null);
  const openPage = (page) => {
    setMenuOpen(false);
    // navigate(`/docs/${id}`);
    setActiveId(page.slug);
    let id = page.id;
    navigate(`/docs/${page.slug}`, { state: { id } });
    // navigate(`/docs/${page.slug}`);
  };

  useEffect(() => {
    const fetchAll = async () => {
      try {
        setLoading(true);

        // const res = await apiClient.get("/categories");
        const res = await apiClient.get("/help-center/category-groups");
        // console.log("RESSSSSS", res);
        const cats = res.data?.data ?? [];

        // const normalized = cats.map((cat) => ({
        //   id: cat.id,
        //   name: cat.name,
        //   description: cat.description,
        //   icon: iconFor(cat.icon),
        //   pages: (cat.pages || [])
        //     .filter((p) => String(p.status || "").toLowerCase() === "published")
        //     .sort((a, b) => (a.order_index ?? 0) - (b.order_index ?? 0))
        //     .map((p) => ({
        //       id: p.id,
        //       title: p.title,
        //       slug: p.slug,
        //       icon: iconFor(p.icon || cat.icon),
        //     })),
        // }));
        const normalized = cats.map((group) => ({
          id: group.id,
          name: group.group_name,
          icon: iconFor(group.icon),

          categories: (group.categories || []).map((cat) => ({
            id: cat.id,
            name: cat.name,
            icon: iconFor(cat.icon || group.icon),

            pages: (cat.pages || [])
              .filter((p) => p.status === "published" && p.is_visible)
              .sort((a, b) => (a.order_index ?? 0) - (b.order_index ?? 0))
              .map((p) => ({
                id: p.id,
                title: p.title,
                slug: p.slug,
              })),
          })),
        }));
        setCategories(normalized);

        const defaults = {};
        normalized.forEach((c, idx) => (defaults[c.id] = false));
        setOpenCats(defaults);
      } catch (e) {
        console.error("Docs landing fetch failed", e);
        setCategories([]);
      } finally {
        setLoading(false);
      }
    };

    fetchAll();
  }, []);

  // auto-open category containing current page
  // useEffect(() => {
  //   if (!id || !categories.length) return;

  //   const owningCat = categories.find((c) =>
  //     (c.pages || []).some((p) => String(p.id) === String(id)),
  //   );

  //   if (owningCat) {
  //     setOpenCats((prev) => ({ ...prev, [owningCat.id]: true }));
  //   }
  // }, [id, categories]);
  // useEffect(() => {
  //   if (!slug || !categories.length) return;

  //   for (const group of categories) {
  //     for (const cat of group.categories || []) {
  //       const found = (cat.pages || []).some(
  //         (p) => String(p.slug) === String(slug),
  //       );

  //       if (found) {
  //         setOpenCategory((prev) => ({
  //           ...prev,
  //           [cat.id]: true,
  //         }));
  //         return;
  //       }
  //     }
  //   }
  // }, [slug, categories]);
  useEffect(() => {
    if (!slug || !categories.length) return;

    for (const group of categories) {
      for (const cat of group.categories || []) {
        const found = (cat.pages || []).some(
          (p) => String(p.slug) === String(slug),
        );

        if (found) {
          setOpenCategoryId(cat.id); // Set directly, not as object
          return;
        }
      }
    }
  }, [slug, categories]);
  // close mobile menu when route changes
  useEffect(() => {
    setMenuOpen(false);
  }, [slug]);

  // find current category + page for breadcrumb
  // const current = useMemo(() => {
  //   if (!id || !categories?.length) return { cat: null, page: null };

  //   for (const cat of categories) {
  //     const page = (cat.pages || []).find((p) => String(p.id) === String(id));
  //     if (page) return { cat, page };
  //   }
  //   return { cat: null, page: null };
  // }, [id, categories]);
  const current = useMemo(() => {
    if (!slug || !categories?.length) {
      return { group: null, cat: null, page: null };
    }

    for (const group of categories) {
      for (const cat of group.categories || []) {
        const page = (cat.pages || []).find(
          (p) => String(p.slug) === String(slug),
        );

        if (page) {
          return { group, cat, page };
        }
      }
    }

    return { group: null, cat: null, page: null };
  }, [slug, categories]);
  const docMetadata = slug
    ? {
        title: `${current.page?.title || "Docs"} | Simplifyte Docs`,
        // description: `Learn about ${current.page?.title || "this topic"} features and how to use them effectively.`,
      }
    : pageMetadata.docs;
  // Skeleton
  const Skel = ({ className = "" }) => (
    <div className={`animate-pulse rounded bg-gray-200 ${className}`} />
  );

  // ✅ Linear-style breadcrumb
  const Breadcrumb = () => {
    if (loading) return <Skel className="h-4 w-60" />;

    const catName = current.cat?.name;
    const pageTitle = current.page?.title;

    return (
      <nav aria-label="Breadcrumb" className="min-w-0">
        <ol className="flex items-center gap-2 text-[13px] min-w-0">
          <li className="shrink-0">
            {/* <button
              type="button"
              onClick={() => navigate("/docs")}
              className="text-gray-500 hover:text-gray-900 transition"
            >
              Docs
            </button> */}
          </li>

          {slug ? (
            <>
              {/* <li className="shrink-0 text-gray-300">/</li> */}

              {/* category - hide on very small */}
              <li className="hidden sm:block shrink-0 text-gray-500">
                {current.group?.name}
              </li>

              <li className="hidden sm:block shrink-0 text-gray-300">/</li>
              <li className="hidden sm:block text-gray-500">
                {current.cat?.name}
              </li>
              {/* page */}
              <li className="hidden sm:block shrink-0 text-gray-300">/</li>

              <li className="min-w-0">
                <span className="block font-semibold text-gray-900 truncate">
                  {pageTitle || "Page"}
                </span>
              </li>
            </>
          ) : null}
        </ol>
      </nav>
    );
  };

  // ✅ Sidebar Skeleton (with pinned footer)
  const SideBarSkeleton = () => {
    const skeletonCategories = Array.from({ length: 5 }).map((_, index) => ({
      id: `skeleton-${index}`,
      pages: Array.from({ length: 3 }),
    }));

    return (
      <div className="h-full flex flex-col">
        <div className="flex-1 px-3 py-4 space-y-1 overflow-y-auto">
          {skeletonCategories.map((cat, catIndex) => (
            <div key={cat.id} className="select-none">
              <div className="w-full flex items-center justify-between px-2 py-2">
                <span className="flex items-center gap-2">
                  <Skel className="h-5 w-5 rounded" />
                  <Skel
                    className={`h-4 ${
                      catIndex % 3 === 0
                        ? "w-28"
                        : catIndex % 3 === 1
                          ? "w-32"
                          : "w-24"
                    }`}
                  />
                </span>
                <Skel className="h-4 w-4" />
              </div>

              <div className="ml-7 mt-2 mb-2 space-y-2">
                {cat.pages.map((_, i) => (
                  <div key={i} className="px-2 py-1.5">
                    <Skel className={`h-3 ${i % 2 === 0 ? "w-40" : "w-44"}`} />
                  </div>
                ))}
              </div>
            </div>
          ))}
        </div>

        <div className="px-3 py-3 border-t border-gray-200 bg-white">
          <div className="px-2 py-2">
            <Skel className="h-4 w-32" />
          </div>
          <div className="px-2 py-2">
            <Skel className="h-4 w-36" />
          </div>
        </div>
      </div>
    );
  };

  // ✅ Sidebar Content (scroll list + pinned footer)
  const SidebarContent = ({ isMobile = false }) => (
    <div className="h-full flex flex-col">
      {/* scrollable list */}
      <div className="flex-1 px-3 py-4 space-y-1 overflow-y-auto">
        {categories.length === 0 ? (
          <div className="text-gray-500 text-sm px-2 py-3">No categories</div>
        ) : (
          categories.map((group) => (
            <div className="pb-10" key={group.id}>
              {/* GROUP TITLE */}
              <div className="Category_group_Class font-medium text-gray-700 text-[13px] text-[#000]">
                <span className="flex flex-row items-center gap-2">
                  {/* <span>{group.icon}</span> */}
                  <span className="text-[20px] leading-none">
                    {group.icon}
                  </span>{" "}
                  <span className="text-[14px] font-semibold">
                    {group.name}
                  </span>
                </span>
              </div>

              {/* CATEGORIES */}
              {group.categories.map((cat) => (
                <div key={cat.id} className="ml-4">
                  {/* CATEGORY BUTTON */}
                  {/* <button
                    onClick={() =>
                      setOpenCategory((prev) => ({
                        ...prev,
                        [cat.id]: !prev[cat.id],
                      }))
                    }
                    className={`w-full flex items-center gap-2 !pl-1  text-[13px]  hover:bg-gray-100 hover:text-[#093A5B] hover:font-semibold
                       rounded h-8
                      ${openCategory[cat.id] ? "text-[#093A5B] font-semibold" : "text-[#6F6E77] "}`}
                  >
                    <ChevronDown
                      size={14}
                      className={`transition ${
                        openCategory[cat.id] ? "rotate-180" : ""
                      }`}
                    />
                    <span>{cat.name}</span>
                  </button> */}
                  <button
                    onClick={() =>
                      setOpenCategoryId(
                        openCategoryId === cat.id ? null : cat.id,
                      )
                    }
                    className={`w-full flex items-center gap-2 !pl-1 text-[13px] hover:bg-gray-100 hover:text-[#093A5B] hover:font-semibold rounded h-8
    ${openCategoryId === cat.id ? "text-[#093A5B] font-semibold" : "text-[#6F6E77]"}`}
                  >
                    <ChevronDown
                      size={14}
                      className={`transition ${openCategoryId === cat.id ? "rotate-180" : ""}`}
                    />
                    <span>{cat.name}</span>
                  </button>

                  {/* PAGES */}
                  {/* openCategory[cat.id] */}
                  {openCategoryId === cat.id && (
                    <div className="ml-4 mt-3 mb-3">
                      {cat.pages.map((page) => (
                        <span
                          key={page.id}
                          // to={`/docs/${page.id}`}
                          onClick={() => openPage(page)}
                          className={`block pl-7 rounded text-[13px] h-8 flex items-center cursor-pointer ${
                            slug === page.slug
                              ? "bg-[#093a5b]/5 text-[#093A5B] font-semibold"
                              : "text-[#6F6E77] hover:bg-gray-100"
                          }`}
                        >
                          <span className="cursor-pointer">{page.title}</span>
                        </span>
                      ))}
                    </div>
                  )}
                </div>
              ))}
            </div>
          ))
        )}
      </div>

      {/* pinned footer */}
      <div className="px-3 py-3 border-t border-gray-200 bg-white">
        <button
          className="inline-flex items-center gap-3 w-full text-left px-2 py-2 rounded-lg
            text-gray-600 hover:text-gray-900 hover:bg-gray-100 transition text-[13px]"
          type="button"
          onClick={() => {
            if (isMobile) setMenuOpen(false);
            navigate(SUPPORT_ROUTE);
          }}
        >
          <BiSupport className="w-4 h-4" />
          Contact support
        </button>
      </div>
    </div>
  );

  return (
    <>
     
     
      {/* <DocCard group_name={categories.name} /> */}
      {/* {console.log("djassa",categories)} */}
      {/* {categories.map((group) => (
        <DocCard key={group.id} group_name={group.name} />
      ))} */}
      <div className="min-h-screen bg-white text-gray-900 flex">
        {/* DESKTOP SIDEBAR */}
        <aside className="hidden xl:block w-[280px] shrink-0 border-r border-gray-200 bg-white sticky top-0 h-screen">
          <div className="h-full flex flex-col">
            {/* Sidebar header */}
            <div className="flex items-center gap-1 px-3 py-3.5 border-b border-gray-200">
              <button
                onClick={() => navigate("/")}
                className="flex items-center gap-2"
                type="button"
              >
                <img src={FaviconImg} alt="Simplifyte" className="w-4 h-4" />
              </button>
              {/* <div className="w-px bg-gray-400 h-5"></div> */}
              <div className="mx-2 h-5 w-px bg-gray-300"></div>
              <button
                onClick={() => navigate("/docs")}
                className="cursor-pointer font-medium text-gray-900 hover:text-gray-600 transition"
                type="button"
              >
                Docs
              </button>
            </div>

            {/* Sidebar body */}
            <div className="flex-1 min-h-0">
              {loading ? <SideBarSkeleton /> : <SidebarContent />}
            </div>
          </div>
        </aside>

        {/* MAIN */}
        <main className="flex-1 min-w-0 Dynamic_Color_Class bg-[rgb(0,0,0,0)]">
          {/* Top header */}
          <div
            // bg-[rgb(0,0,0,0)]
            className={`sticky top-0 z-40 bg-white flex items-center height_Class border-b border-gray-200 p-4 `}
          >
            {/* {slug && `${slug ? `/${slug}` : ""}` ? (
              ""
            ) : (
              <span className="hidden md:block text-[13px] font-medium text-[#6F6E77]">
                Home
              </span>
            )} */}
            {!slug && (
              <span className="hidden xl:block text-[13px] font-medium text-[#6F6E77]">
                Home
              </span>
            )}
            {/* Mobile left */}
            <button
              onClick={() => navigate("/")}
              className="Icon_Mobile_Only"
              // xl:hidden mr-0.5 inline-flex items-center gap-2 !pl-2
              type="button"
            >
              <img src={FaviconImg} alt="Simplifyte" className="w-4 h-4" />
            </button>
            <div className="xl:hidden mx-2 h-5 w-px bg-gray-300"></div>
            <button
              type="button"
              onClick={() => navigate("/docs")}
              className="xl:hidden ml-0.5 font-semibold text-[18px] text-gray-900"
            >
              Docs
            </button>

            {/* Breadcrumb (desktop + mobile) */}
            <div className="hidden md:block ml-3 min-w-0 flex-1">
              <Breadcrumb />
            </div>

            {/* Login + Get Started */}
            <div className="ml-auto flex items-center gap-2">
              <a
                href="https://app.simplifyte.com/login"
                target="_blank"
                rel="noopener noreferrer"
                className="inline-flex items-center justify-center h-9 px-4 text-[13px] font-medium text-gray-700 hover:text-gray-900 transition"
              >
                Login
              </a>
              <a
                href="https://app.simplifyte.com/login"
                target="_blank"
                rel="noopener noreferrer"
                style={{ backgroundColor: "#093A5B" }}
                className="inline-flex items-center justify-center h-9 px-4 rounded-full text-white text-[13px] font-medium hover:opacity-90 active:scale-[0.98] focus:outline-none transition"
              >
                Get Started
              </a>
            </div>

            {/* Mobile menu toggle */}
            <button
              type="button"
              onClick={() => setMenuOpen((v) => !v)}
              className="xl:hidden p-1 ml-1 rounded-md hover:bg-gray-100"
              aria-label="Toggle menu"
            >
              {menuOpen ? (
                <X className="w-5 h-5" />
              ) : (
                <Menu className="w-5 h-5" />
              )}
            </button>
          </div>

          {/* Page content */}
          <div className="">
            <Outlet context={{ categories, loading }} />
          </div>

          {/* MOBILE MENU */}
          {menuOpen && (
            <>
              <div
                className="fixed inset-0 bg-black/30 z-30 md:hidden"
                onClick={() => setMenuOpen(false)}
              />
              <div className="fixed top_Class left-0 right-0 z-50 xl:hidden bg-white border-b border-gray-200 shadow-lg">
                <div className="h-[calc(100vh-56px)] overflow-hidden">
                  {loading ? <SideBarSkeleton /> : <SidebarContent isMobile />}
                </div>
              </div>
            </>
          )}
        </main>
      </div>
    </>
  );
}
